import React from 'react';
import { Switch, Route } from 'react-router-dom';

import InvoicingList from './Invoicing/InvoicingList';
import InvoicingAccount from './Invoicing/InvoicingAccount';
import ActivitySummaryList from './ActivitySummary/ActivitySummaryList';
import ActivitySummaryDetails from './ActivitySummary/ActivitySummaryDetails';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/reports">
      <InvoicingList />
    </Route>
    <Route exact path="/reports/:accountId">
      <InvoicingAccount />
    </Route>
    <Route exact path="/account-activity">
      <ActivitySummaryList />
    </Route>
    <Route exact path="/account-activity/:companyName">
      <ActivitySummaryDetails />
    </Route>
  </Switch>
);

export default Routes;
